import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import SideBar from './components/SideBar';
import ToolFrame from './pages/ToolFrame';
import UsersManager from './pages/UsersManager';
import OperationsManager from './pages/OperationsManager';
import config from './config';
import './styles/global.css';
import './styles/light-theme.css';

function App() {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem(config.userKey);
    return saved ? JSON.parse(saved) : null;
  });

  // Injection des couleurs client via CSS variables
  useEffect(() => {
    document.documentElement.style.setProperty('--primary', config.primaryColor);
    document.documentElement.style.setProperty('--accent',  config.accentColor);
    document.title = config.clientName + ' — CRM';
  }, []);

  if (!user) {
    return (
      <Router>
        <Routes>
          <Route path="*" element={<Login setUser={setUser} />} />
        </Routes>
      </Router>
    );
  }

  const isAdmin = ['admin', 'superadmin'].includes(String(user?.role || '').toLowerCase());
  const isSuperAdmin = String(user?.role || '').toLowerCase() === 'superadmin';
  const allowedApps = isAdmin
    ? config.apps
    : config.apps.filter(app => app.key === 'planning');

  return (
    <Router>
      <div className="admin-page">
        <SideBar user={user} setUser={setUser} />

        <div className="crm-main-window">
          <header className="crm-window-bar">
            <strong>Isolacier Workspace</strong>
            <span className="crm-window-status">Connecté · {user?.username}</span>
          </header>
          <div className="iframe-wrapper">
            <Routes>
              {allowedApps.map(app => (
                <Route
                  key={app.key}
                  path={`/${app.key}`}
                  element={<ToolFrame app={app} />}
                />
              ))}
              {isSuperAdmin && (
                <Route path="/users" element={<UsersManager currentUser={user} />} />
              )}
              {isAdmin && <Route path="/equipe" element={<OperationsManager view="team" />} />}
              {isAdmin && <Route path="/vehicules" element={<OperationsManager view="vehicles" />} />}
              <Route path="*" element={<Navigate to={config.defaultRoute} />} />
            </Routes>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;
